import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TimezoneState {
  value: string;
  label: string;
}

const initialState: TimezoneState = {
  label: "America/Los_Angeles (PST)",
  value: "America/Los_Angeles",
};

const timezoneSlice = createSlice({
  name: "timezone",
  initialState,
  reducers: {
    setTimezoneDetails: (
      state,
      action: PayloadAction<Partial<TimezoneState>>
    ) => {
      return { ...state, ...action.payload };
    },
    resetTimezoneDetails: () => initialState,
    setTimezoneError: (state, action: PayloadAction<string>) => {
      // Handle timezone error here if needed
    },
  },
});

export const { setTimezoneDetails, resetTimezoneDetails, setTimezoneError } =
  timezoneSlice.actions;
export default timezoneSlice.reducer;
